import styles from './FAQ.module.scss'

interface FAQList {
  questionText: string
  answerText: string
}

const FAQLists: FAQList[] = [
  {
    questionText: 'フロントエンドだけでなくバックエンドもお願いできますか？',
    answerText: 'フロントエンドだけではなくバックエンドに関しても実績が多数ございます。お気軽にご相談ください。',
  },
  {
    questionText: 'サーバー環境の構築・運用もお願いできますか？',
    answerText:
      'AWS テクノロジーパートナーとして登録されており運用について豊富な実績があります。安心してお任せください。',
  },
  {
    questionText: 'まだ仕様が固まっていません。。。',
    answerText:
      'フロントエンド開発だけでなくサービス開発やUI設計も得意としております。ご予算に応じて上流工程から参画も可能です。',
  },
  {
    questionText: 'デザインファイルがありません',
    answerText:
      '管理画面でUIフレームワークを利用する場合はデザインがなくても実装可能です。情報設計に関しても経験豊富な弊社デザイナーが対応いたします。もちろんデザインを作成にも対応いたします。',
  },
]

const FAQ: React.VFC = () => {
  const FAQList = FAQLists.map(({ questionText, answerText }) => (
    <li className={styles.li} key={questionText}>
      <div className={styles.FAQWrapper}>
        <div className={styles.questionWrapper}>
          <p className={styles.question}>Q</p>
          <p className={styles.questionText}>{questionText}</p>
        </div>
        <div className={styles.answerWrapper}>
          <p className={styles.answer}>A</p>
          <p className={styles.answerText}>{answerText}</p>
        </div>
      </div>
    </li>
  ))
  return (
    <section className={styles.FAQ} id="FAQ">
      <p className={styles.title}>よくある質問</p>
      <ul className={styles.FAQList}>{FAQList}</ul>
    </section>
  )
}

export default FAQ
